import countries from "__generated__/countries.json";
import { CountryCode, CountryPreviewFragment } from "__generated__/graphql";

export const getCountryOptions = (
  locale?: string,
): CountryPreviewFragment[] => {
  // Use browser's built-in Intl API for country names
  const displayNames = new Intl.DisplayNames([locale || "en"], {
    type: "region",
  });

  return countries.map((country) => ({
    code: country.code as CountryCode,
    name: getCountryName(country.code, country.name, displayNames),
    emojiFlag: country.emoji_flag,
  }));
};

const getCountryName = (
  countryCode: string,
  fallbackName: string,
  displayNames: Intl.DisplayNames,
): string => {
  try {
    return displayNames.of(countryCode) || fallbackName;
  } catch {
    // Fallback to original name if country code is not recognized
    return fallbackName;
  }
};
